import { Component, ElementRef, EventEmitter, HostListener, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ListingCategory, SearchType } from '../../classes/enums';
import { User } from '../../classes/user';

@Component({
  selector: 'app-site-links',
  templateUrl: './site-links.component.html',
  styleUrls: [
    './site-links.component.scss',
    './site-links.component.desktop.scss'
  ],
})
export class SiteLinksComponent implements OnInit {
  @Input() platform: ListingCategory;
  @Input() totalFavourites: number;
  @Input() faveIcon: string;
  @Input() accountIcon: string;
  @Input() currentUser: User;
  @Input() showMyRemaxMenu: Boolean;
  @Output() onListingsClick: EventEmitter<void> = new EventEmitter();
  @Output() toggleLuxury: EventEmitter<void> = new EventEmitter();
  @Output() toMyRemax: EventEmitter<void> = new EventEmitter();
  @Output() toggleRightNav: EventEmitter<void> = new EventEmitter();
  @Output() closeRightNav: EventEmitter<void> = new EventEmitter();
  @Output() openRegisterLogin: EventEmitter<void> = new EventEmitter();
  @ViewChild('siteLinksRef') siteLinksRef: ElementRef;

  isListingsOpen: boolean = false;
  isBuyingOpen: boolean = false;
  isSellingOpen: boolean = false;
  isFindAnAgentOpen: boolean = false;
  isAboutRemaxOpen: boolean = false;
  isMediaOpen: boolean = false;
  isJoinRemaxOpen: boolean = false;
  isBlogOpen: boolean = false;
  // enums
  ListingCategory = ListingCategory;
  SearchType = SearchType;

  constructor() { }

  ngOnInit() { }

  toggleDropdown(type: string, $event: Event, focusableElement?) {
    if ($event) {
      $event.stopPropagation();
    }
    setTimeout(() => {

      if (type) {
        switch (type) {
          case 'isListingsOpen': {
            this.isListingsOpen = !this.isListingsOpen;
            break;
          }
          case 'isBuyingOpen': {
            this.isBuyingOpen = !this.isBuyingOpen;
            break;
          }
          case 'isSellingOpen': {
            this.isSellingOpen = !this.isSellingOpen;
            break;
          }
          case 'isFindAnAgentOpen': {
            this.isFindAnAgentOpen = !this.isFindAnAgentOpen;
            break;
          }
          case 'isAboutRemaxOpen': {
            this.isAboutRemaxOpen = !this.isAboutRemaxOpen;
            break;
          }
          case 'isMediaOpen': {
            this.isMediaOpen = !this.isMediaOpen;
            break;
          }
          case 'isJoinRemaxOpen': {
            this.isJoinRemaxOpen = !this.isJoinRemaxOpen;
            break;
          }
          case 'isBlogOpen': {
            this.isBlogOpen = !this.isBlogOpen;
            break;
          }
        }
      }
    });
    this.isListingsOpen = type === 'isListingsOpen' && this.isListingsOpen;
    this.isBuyingOpen = type === 'isBuyingOpen' && this.isBuyingOpen;
    this.isSellingOpen = type === 'isSellingOpen' && this.isSellingOpen;
    this.isFindAnAgentOpen = type === 'isFindAnAgentOpen' && this.isFindAnAgentOpen;
    this.isAboutRemaxOpen = type === 'isAboutRemaxOpen' && this.isAboutRemaxOpen;
    this.isMediaOpen = type === 'isMediaOpen' && this.isMediaOpen;
    // Checking if Join Remax dropdown is opened
    this.isJoinRemaxOpen = type === 'isJoinRemaxOpen' && this.isJoinRemaxOpen;
    this.isBlogOpen = type === 'isBlogOpen' && this.isBlogOpen;

    if (focusableElement) {
      setTimeout(() => focusableElement.focus());
    }
  }

  @HostListener('window:click', ['$event'])
  onPageClick($event: MouseEvent) {
    // Hide all the dropdowns if the dropdowns are open and they click something not a dropdown
    // Added the isJoinRemax to below if statement to hide Join Remax dropdown on element outside click
    if ((this.isAboutRemaxOpen || this.isBuyingOpen || this.isBuyingOpen ||
      this.isFindAnAgentOpen || this.isListingsOpen || this.isMediaOpen ||
      this.isSellingOpen || this.isJoinRemaxOpen) &&
      !(this.siteLinksRef.nativeElement).contains($event.toElement)) this.toggleDropdown(null, $event);
  }

  readonly showStyles = {
    opacity: 1,
    visibility: 'visible',
    height: '100%'
  }

  readonly hideStyles = {
    opacity: 0,
    visibility: 'hidden',
    height: '0'
  }

  focusNext(event: KeyboardEvent) {
    try {
      if (event.target['parentElement'].nextElementSibling.firstChild) {
        event.preventDefault();
        event.target['parentElement'].nextElementSibling.firstChild.focus();
      }
    }
    catch (err) {
      console.error(err);
    }
  }

  focusPrevious(event: KeyboardEvent) {
    try {
      if (event.target['parentElement'].previousElementSibling.firstChild) {
        event.preventDefault();
        event.target['parentElement'].previousElementSibling.firstChild.focus();
      }
    }
    catch (err) {
      console.error(err);
    }
  }
}
